/*
 * @Author: dingguoqing 370541946@qq.com
 * @Date: 2025-03-21 09:09:46
 * @FilePath: /insuranceagent-ui/src/const/website.js
 * @Description: 网站配置
 */
import {isBxIe, isBxXsm, isBxIeBw} from '@/config/env'

/**
 * ©2017-2024广东美保保险经纪有限公司 京ICP备2021021655号-3
 * 经营保险经纪业务许可证编号:269602000000800 | 中国保监会网销许可
 */

const title = isBxIe() ? 'IE保' : isBxXsm() ? '新市民保平台' : '投保平台'

export default {
	title,
	subtitle: title,
	copyright: isBxIeBw() ? '©2017-2024博维保险经纪有限公司' : '©2017-2025广东美保保险经纪有限公司',
	icp: isBxIeBw() ? '京ICP备17042426号-4' : '京ICP备2021021655号-3',
	isFirstPage: true, // 配置首页不可关闭
	key: 'pigx', // 配置主键,目前用于存储
	whiteList: ['/login', '/404', '/401', '/lock'], // 配置无权限可以访问的页面
	whiteTagList: ['/login', '/404', '/401', '/lock'], // 配置不添加tags页面 （'/advanced-router/mutative-detail/*'——*为通配符）
	firstPage: {
		label: '首页',
		value: '/wel/index',
		params: {},
		query: {},
		group: [],
		close: false,
	},
	// 配置菜单的属性
	menu: {
		props: {
			label: 'label',
			path: 'path',
			icon: 'icon',
			children: 'children',
		},
	},
}
